export default "__VITE_ASSET__7194c295__"